import 'bootstrap';
import 'bootstrap/scss/bootstrap.scss';
// import { Utils } from 'utils/UtilsDefault';
import { IS_CORDOVA } from 'constants/constants';
// import ScrollToTop from './ScrollToTop';
import 'jquery';
import 'popper.js';
import React, { useEffect } from 'react';
import Routes from 'routes/Routes';
import './assets/scss/main.scss';
import Headers from './Headers';
import TagManager from 'react-gtm-module';


// if (Utils.isIOS() && Utils.isSafari() && !IS_CORDOVA) {
//   window.$('html').addClass('is-safari-or-ios');
// }
const tagManagerArgs = {
  gtmId: 'GTM-TP7LZV2'
}

declare let window: any;

const App: React.FC = () => {
  TagManager.initialize(tagManagerArgs);
  let intervalCssDuplicated = null;
  const setCookies = () => {
    let node = document.createElement('script');
    node.src = 'https://cdn-prod.securiti.ai/consent/cookie-consent-sdk-loader.js';
    const dataTenantuuid = '13a6791d-158d-43ce-a8f8-813a2eb49ef1';
    const dataDomainuuid = '097c5487-8360-484a-b425-a0750297cdd8';
    node.setAttribute('data-tenant-uuid', dataTenantuuid);
    node.setAttribute('data-domain-uuid', dataDomainuuid);
    node.setAttribute('data-backend-url', 'https://app.securiti.ai');
    node.setAttribute('data-skip-css', 'false');
    node.defer = true;
    let parentNode = document.head;
    parentNode.appendChild(node);

    let script = document.createElement('script');
    script.src = 'https://cdn-prod.securiti.ai/consent/auto_blocking/13a6791d-158d-43ce-a8f8-813a2eb49ef1/097c5487-8360-484a-b425-a0750297cdd8.js';
    parentNode.appendChild(script);

    node.addEventListener('load', function () {
      intervalCssDuplicated = setInterval(removeDuplicatedCssClass, 200);
    });

    setTimeout(function () {
      const link = document.getElementsByClassName('cc-link')[0] as HTMLAnchorElement | null;
      if(link !== undefined) {
        link.href = 'https://www.vaidevoala.com.br/documentos/vaidevoala_politicadeprivacidade.pdf';
      }
    }, 1500);
  };
  const removeDuplicatedCssClass = (): void => {
    let styles = document.getElementsByTagName('style');
    for (var i = 0; i < styles.length; i++) {
      if (styles[i].innerHTML.indexOf('.cc-window') !== -1) {
        styles[i].innerHTML = '';
        styles[i].remove();
        clearInterval(intervalCssDuplicated);
      }
    }
  };

  useEffect(() => {
    if (!IS_CORDOVA) {
      setCookies();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Headers />
      <Routes />
    </>
  );
};

export default App;
